import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate, useParams} from "react-router-dom";
import LineageDrawer from "../components/LineageDrawer/LineageDrawer";
import { fetchVersionLineage } from "../store/app/DataQualityStatus/DataQualitySlice";
import LoaderSpin from "../components/loaderSpin/LoaderSpin";


const VersionLineage = () => {

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const { versionId } = useParams();
  const searchParams = new URLSearchParams(location.search);
  const validOnly = searchParams.get("validOnly") === "true";
  


  const versionLineagePayload = useSelector((state) => state.dataQualityReducer.versionLineage );
  const isSpinnerVisible = useSelector((state) => state.dataQualityReducer.loading );


  const params = {
    nodeTooltipKeys: [
      { key: "version_id", displayKey: "Version ID" },
      { key: "domain_name", displayKey: "Domain" },
      { key: "class_name", displayKey: "Class" },
      { key: "product_name", displayKey: "Product" },
      { key: "reference_date", displayKey: "Reference Date" },
      { key: "status_name", displayKey: "Status" },
    ],
    lineTooltipKeys: [
      { key: "process_name", displayKey: "Process" },
      { key: "process_type_name", displayKey: "Process Type" },
      { key: "process_is_manual_validation", displayKey: "Is Manual Validation" },
      { key: "process_revision_num", displayKey: "Revision Number" },
      { key: "process_revision_release_date", displayKey: "Revision Release Date" },
      { key: "process_revision_release_notes", displayKey: "Revision Release Notes" },
    ],
    primaryKey: "version_id",
    originId: versionId,
    initialValidOnly: validOnly,
  };

  useEffect(() => {
    dispatch(fetchVersionLineage(versionId, { validOnly }));
  },[dispatch, navigate, versionId, validOnly]);


  return (
    <>
    <LoaderSpin isVisible={isSpinnerVisible} />
    <LineageDrawer data={versionLineagePayload} params={params} />
    </>
  );

};


export default VersionLineage;